/* eslint-disable complexity */
import EServiceEngineerActions from '@r1-frontend/service-engineer-visit/constants/actions';
import initialState, { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

import * as actions from '../actions/simple';

// автоматически собираем все типы ActionCreator
export type InferValueTypes<T> = T extends { [key: string]: infer U } ? U : never;

export type TAllServiceEngineerActions = ReturnType<InferValueTypes<typeof actions>>

/**
 * Общие типы и интерфейсы для хранилища
 */

export interface IAction<T extends string, U = any> {
    type: T,
    payload: U,
}

export type TDispatch = (action: IAction<string, unknown>) => void

const reducer = (
    state: TInitialState = initialState,
    action: TAllServiceEngineerActions,
): TInitialState => {
    switch (action.type) {
        case EServiceEngineerActions.INITIALIZED: {
            return {
                ...state,
                _initialized: true,
                _incomingData: action.payload.incomingData,
            };
        }
        case EServiceEngineerActions.SET_DELIVERY_OPTIONS: {
            return {
                ...state,
                deliveryOptions: action.payload.options,
            };
        }
        case EServiceEngineerActions.SET_SLOTS: {
            return {
                ...state,
                slots: {
                    ...state.slots,
                    ...action.payload.slots,
                },
            };
        }
        case EServiceEngineerActions.SET_ERROR_MESSAGE: {
            return {
                ...state,
                errorMessage: action.payload,
            };
        }
        case EServiceEngineerActions.UPDATE_HOURS_FOR_DAY: {
            return {
                ...state,
                slots: {
                    ...state.slots,
                    [action.payload.date]: {
                        ...state.slots[action.payload.date],
                        hours: action.payload.hours,
                    },
                },
            };
        }
        case EServiceEngineerActions.SET_IS_LOADING: {
            return {
                ...state,
                _loading: action.payload,
            };
        }
        case EServiceEngineerActions.SELECT_DELIVERY_OPTION: {
            return {
                ...state,
                _requestedDays: 0,
                _selectedSlotAvailable: null,
                slots: {},
                selected: {
                    ...state.selected,
                    deliveryOption: action.payload.deliveryOption,
                },
            };
        }
        case EServiceEngineerActions.SELECT_DATE: {
            return {
                ...state,
                _selectedSlotAvailable: null,
                selected: {
                    ...state.selected,
                    date: action.payload.date,
                },
            };
        }
        case EServiceEngineerActions.SELECT_HOUR: {
            return {
                ...state,
                _selectedSlotAvailable: null,
                selected: {
                    ...state.selected,
                    hour: action.payload.hour,
                },
            };
        }
        case EServiceEngineerActions.SET_COMMENT: {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    comment: action.payload.comment,
                },
            };
        }
        case EServiceEngineerActions.FLUSH_HOUR: {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    hour: undefined,
                },
            };
        }
        case EServiceEngineerActions.REQUEST_SLOTS: {
            return {
                ...state,
                _requestedDays: action.payload.days,
            };
        }
        case EServiceEngineerActions.CHANGE_SELECTED_SLOT_STATE: {
            return {
                ...state,
                _selectedSlotAvailable: action.payload.state,
            };
        }
        case EServiceEngineerActions.CONFIRM: {
            return { ...state };
        }
        default: {
            const unknownAction: never = action;
            return state || unknownAction;
        }
    }
};

export default reducer;
